import React, { useMemo } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './TestAnalytics.css';

const CompletionChart = ({ results }) => {
  const data = useMemo(() => {
    if (!results || results.length === 0) return [];
    return results.map(r => ({
      name: r.student_name,
      score: r.score,
      time: Math.round(r.time_taken_seconds / 60) // convert to mins
    }));
  }, [results]);

  if (data.length === 0) {
    return (
      <div className="ta-chart-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
        <p style={{ color: '#64748b' }}>Not enough data for Time vs Score Analysis.</p>
      </div>
    );
  }

  return (
    <div className="ta-chart-container">
      <h4 className="ta-chart-title">Time vs Score Analysis</h4>
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: -20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis type="number" dataKey="time" name="Time (mins)" unit="m" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis type="number" dataKey="score" name="Score" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
          <Tooltip cursor={{ strokeDasharray: '3 3' }} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }} />
          <Scatter name="Students" data={data} fill="#6d28d9" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletionChart;
